import React from 'react'
import { CrossIcon, RotateIcon } from '../../icons'
import styles from './index.module.css'
import Cropper from 'react-easy-crop'
import getCroppedImg from './cropImg'

const EditImageModal = ({ onClose, file, setFile }) => {
    const [rotate, setRotate] = React.useState(0)
    const [crop, setCrop] = React.useState({ x: 0, y: 0 })
    const [zoom, setZoom] = React.useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null)

    const onSave = () => {
        getCroppedImg(file, croppedAreaPixels, rotate).then((croppedImage) => {
            setFile(croppedImage)
            onClose()
        })
    }


    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        console.log(croppedAreaPixels)
        setCroppedAreaPixels(croppedAreaPixels)
    }


    return (
        <div className={styles.overlay + " requires-no-scroll"}>
            <div className={styles.container}>
                <div className={styles.header}>
                    Edit Photo
                </div>
                <Cropper
                    image={file}
                    rotation={rotate}
                    crop={crop}
                    onCropChange={setCrop}
                    aspect={4 / 3}
                    zoom={zoom}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                    zoomWithScroll
                    classes={{ containerClassName: styles.crop_container, cropAreaClassName: "cropArea", mediaClassName: "media" }}
                />
                <div className={styles.row}>
                    <div className={styles.tool_button} onClick={() => {
                        setRotate(rotate - 90)
                    }} style={{ flex: 0.5 }}>
                        <RotateIcon size={20} fill={"#851718"} style={{transform: "rotate(135deg)"}}/>
                        <div className={styles.label}>
                            Rotate
                        </div>
                    </div>
                    <div className={styles.tool_button}>
                        <div className={styles.label}>
                            Crop
                        </div>
                        <input className={styles.slider} type='range' min={1} max={4} step={0.1} value={zoom} onChange={(e) => setZoom(e.target.value)} />
                    </div>
                    <div className={`banner-submit-button`} style={{ display: 'flex' }} onClick={onSave}>
                        Save
                    </div>
                </div>
                <CrossIcon className={styles.cross_icon} onClick={onClose} />
            </div>
        </div>
    )
}

export default EditImageModal